<template>
  <div class="vehicles-list">
    <former-container>
      <state-messages
        key="vehicles-list-states"
        class="vehicles-list-states"
        :state="currentState"
      >
        <template v-slot:loading>
          Carregando veículos
        </template>

        <template v-slot:error>
          Algo deu errado enquanto tentávamos carregar os veículos.
          Por favor, tente novamente.
        </template>

        <template v-slot:empty>
          Nenhum veículo encontrado
        </template>
      </state-messages>

      <template v-for="vehicle in currentVehicles">
        <former-section-list
          :key="vehicle.id"
          class="vehicles-list-section"
          :editable="false"
          :section="sections(vehicle)"
        />

        <vehicles-list-item
          :key="`vehicle-${vehicle.id}-actions`"
          :update-action="actions.update"
          :vehicle="vehicle"
          class="vehicles-list-buttons"
        />
      </template>
    </former-container>
  </div>
</template>

<script>
  import { input } from '@/_CRUDL/helpers/form/fields';
  import dataSort from '@/_CRUDL/helpers/data/sort';

  import StateMessages from '@/components/State/Messages.vue';

  import VehiclesListItem from '@/views/Settings/Vehicles/List/Item.vue';

  import FormerContainer from '@/components/Former/Container.vue';
  import FormerSectionList from '@/components/Former/Section/List.vue';

  export default {
    name: 'VehiclesList',
    components: {
      StateMessages,
      VehiclesListItem,
      FormerContainer,
      FormerSectionList,
    },
    props: {
      items: {
        type: Array,
        default() {
          return [];
        },
      },
      vehicles: {
        type: Object,
        default() {
          return {};
        },
      },
      actions: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      currentVehicles() {
        const { items } = this.vehicles.list;

        return dataSort(items);
      },
      currentState() {
        const {
          error,
          items,
          loading,
        } = this.vehicles.list;

        if (loading) {
          return 'loading';
        }

        if (error) {
          return 'error';
        }

        return Object.keys(items).length ? 'ready' : 'empty';
      },
    },
    methods: {
      sections(vehicle) {
        const title = [];
        const subtitle = [];

        const items = this.items
          .map(item => ({
            ...input,
            id: item.id,
            label: item.label,
            value: item.formatter ? item.formatter(vehicle[item.field]) : vehicle[item.field],
            mask: item.mask,
        }));

        const {
          molicar_code: molicarCode,
          fipe_code: fipeCode,
          name,
          version,
          vehicle_type: vehicleType,
          vehicle_brand: vehicleBrand,
        } = vehicle;

        const vehicleNameLabel = name || 'Sem nome';
        const vehicleVersionLabel = version || 'Sem versão';
        title.push(vehicleNameLabel, vehicleVersionLabel);

        const vehicleBrandLabel = vehicleBrand.name || 'Sem marca';
        subtitle.push(vehicleType.name, vehicleBrandLabel);

        if (molicarCode || fipeCode) {
          items.unshift({
            id: 'vehicleSeparator',
            separator: true,
          });

          if (fipeCode) {
            items.unshift({
              ...input,
              id: 'fipeCode',
              label: 'Fipe',
              value: fipeCode,
            });
          }

          if (molicarCode) {
            items.unshift({
              ...input,
              id: 'molicarCode',
              label: 'Molicar',
              value: molicarCode,
            });
          }
        }

        return {
          id: vehicle.id,
          title: title.join(' - '),
          subtitle: subtitle.join(', '),
          collapsable: true,
          startCollapsed: true,
          items,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .vehicles-list {
    margin-top: $gutter-big;
  }

  .vehicles-list-section {
    border-top: 1px solid $gray-dark;

    .vehicles-list-states + & {
      border-top: none;
    }
  }

  .vehicles-list-buttons {
    display: flex;
    padding: 0 var(--product--pwa--horizontal) $gutter-big;

    @media all and (min-width: $breakpoint-desktop) {
      padding: 0 var(--product--pwa--horizontal) $gutter-big;
    }

    .former-section-list-collapsed + & {
      display: none;
    }
  }
</style>
